import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Routes } from '@angular/router';

import { UserService, SeedDataService} from '../../Services/index';

import { TreeModule, TreeNode, InputTextModule, ButtonModule, DialogModule, Message } from 'primeng/primeng';

import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

//import {ROUTER_DIRECTIVES, Routes} from '@angular/router';

import {AutoCompleteModule, ConfirmationService} from 'primeng/primeng';

import { BusinessUnit } from '../../Models/BusinessUnit';

import { } from 'rxjs';


@Component({
    templateUrl: './business.unit.html'   
})

export class BusinessUnitComponent implements OnInit {
    timer :any = 0;
    delay: number = 200;
    IsDoubleClick: boolean = false;
    public Label: string;
    public ButtonCaption: string;
    public loading: boolean;
    public files: TreeNode[];   
    public treedata: TreeNode[];
    public tData: any;
    public selectedFiles: TreeNode[];
    public selectedFile: any;
    public trees = {};
    public selectedNodes: any;

    public addDisable = true;
    public editDisable = true;
    public deleteDisable = true;

    public modelDialoglDisplay: boolean = false;
    public AddFor: string = '';
    public UnitName: any;

    public bussinessUnit: BusinessUnit;

    selectedBusinessUnit: BusinessUnit;

    newBusinessUnit: boolean;

    bussinessUnits: BusinessUnit[];

    msgs: Message[] = [];

    userform: BusinessUnit;

    submitted: boolean;

    constructor(private seedDataService: SeedDataService, private fb: FormBuilder, private confirmationService: ConfirmationService) {
        
        this.bussinessUnit = new BusinessUnit();
        var tree = [];
        this.seedDataService.GetDeliveryUnitData(0).subscribe((trees: TreeNode[]) => {
            console.log(trees);
            this.files = trees;
            //console.log(this.files);
            this.expandAll();
        });

        var tree = [];

    }


    public BusinessUnitActionType = {
        AddNew: 'Add',
        Edit: 'Update',
        Delete: 'Remove'
    };

  nodeSelect(event: any) {
    //  window.setTimeout(
  
              if (this.selectedNodes.parentID == 0) {
                  this.addDisable = false;
                  this.editDisable = true;
                  this.deleteDisable = true;
              }
              else {
                  this.addDisable = false;
                  this.editDisable = false;
                  this.deleteDisable = false;
              }
             
          
         

     // console.log(this.selectedNodes);
      
     
  }
  nodeSelect1(event: any) {
      //  window.setTimeout(
      clearTimeout(this.timer);
      this.IsDoubleClick = true;
      this.EDIT();
      // console.log(this.selectedNodes);

  }
  ngOnInit()
  {        
      this.loading = false;
      this.IsDoubleClick = false;
      this.userform = this.fb.group({
          'unitName': ["", Validators.required]
      });

        var tree = [];        
        this.seedDataService.GetDeliveryUnitData(0).subscribe((trees: TreeNode[]) => {
           
            this.files = trees;
            //console.log(this.files);
            this.expandAll();
        });
       
        var tree = [];

  }

  

  Cancel() {
      this.modelDialoglDisplay = false;
      //this.modelDialoglDisplayDelete = false;
  }

  ADD()
  {
      this.loading = false;
      this.ButtonCaption = "Add";
      this.Label = "Add Unit";
      this.newBusinessUnit = true;
      this.modelDialoglDisplay = true;
     // this.ngOnInit();
      
  }  

  EDIT()
  {
      this.loading = false;
      this.Label = "Edit Unit";
      this.ButtonCaption = "Save";
     // alert(this.selectedNodes.label)
      this.newBusinessUnit = false;
      this.modelDialoglDisplay = true;
      this.bussinessUnit.unitName = this.selectedNodes.label;
      //this.ngOnInit();
  }

    PerformBusinessUnitAction(value: any)
    {
        this.loading = true;
        //alert(this.newBusinessUnit);
        if (this.newBusinessUnit)
        {
            //alert(this.selectedNodes.name);
            this.AddFor = "Add New Unit: " + this.selectedNodes.label;
            this.seedDataService.SaveDeliveryUnitData(this.selectedNodes.id, value.unitName, 0, null, null).subscribe((data: any) => {
                this.modelDialoglDisplay = false;
                this.ngOnInit();
                this.loading = false;
            });
          
        }
        else
        {
           // alert(this.selectedNodes.name);           
            //alert(value.unitName);
            this.AddFor = "Edit Unit: " + this.selectedNodes.label;
            this.seedDataService.SaveDeliveryUnitData(this.selectedNodes.parentID, value.unitName, this.selectedNodes.id,null,null).subscribe((data: any) => {
                this.modelDialoglDisplay = false;
                this.ngOnInit();

            });
        }
        
        
    }
    expandAll() {
        this.files.forEach(node => {
            this.expandRecursive(node, true);
        });
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children  ) {
            node.children.forEach(childNode => {
             
                if (childNode.children !=undefined && childNode.children.length > 0) {
                    this.expandRecursive(childNode, isExpand);
                }
            });
        }
    }
    DELETE() {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
                this.seedDataService.DeleteDeliveryUnitData(this.selectedNodes.id).subscribe((data) => {
                    this.modelDialoglDisplay = false;
                    var tree = [];
                    this.ngOnInit();
                    this.msgs = [];
                    this.msgs.push({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
                });
                
            }
        });
    }

}
class PrimeBusinessUnit implements BusinessUnit {
    constructor(
        public id?: any,
		public parentID?: any,
		public name?: any,
		public active?: any,
		public unitName?: any
    ) { }
}






// WEBPACK FOOTER //
// ./src/app/Components/BusinessUnit/business.unit.ts